import React from 'react';
import FormItemEditorRenderForAutoLookup from './FormItemEditorRenderForAutoLookup';
import FormItemDateDisplay from '../display/FormItemDateDisplay';
require('../../styles/FormItemRender.css');

export default class FormItemDateRenderForAutoLookup extends FormItemEditorRenderForAutoLookup
{
	constructor(props) {
		super(props);
	}

	getDisplay(_value)
	{
		if(_value == null || _value == undefined)
			_value = this.props.value;

		//Gongqi 如果继承了DataType 则此处肯定不是空 是空说明没有继承DataType 没有格式化显示设置 所以直接返回后台数据
		if(!this.props.seperator)
			return _value;

		_value = FormItemDateDisplay.getDisplayText(_value,this.props.show1970,this.props.seperator,this.props.numOfDay,this.props.numOfMonth,this.props.numOfYear);

		return _value;
	}

	render()
	{
		let newValue = this.props.rowData[this.props.dataField];
		let displayValue = this.getDisplay(newValue);

		
		return(
			<div className="gongqi_render_select" style={{padding:'3px'}} ref={ node => this.componentLabel = node }>
				{displayValue}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/formItem/renders/FormItemDateRenderForAutoLookup.js